"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Explanation_1 = __importDefault(require("../Explanation"));
const common_1 = require("./common");
const SommeNode = ({ explanation, nodeValue, unit }) => (jsx_runtime_1.jsx(StyledSomme, { children: jsx_runtime_1.jsx(common_1.Mecanism, Object.assign({ name: "somme", value: nodeValue, unit: unit }, { children: jsx_runtime_1.jsx(Table, { explanation: explanation }, void 0) }), void 0) }, void 0));
exports.default = SommeNode;
// We want to put non applicable rules a the bottom of list #1055
function sortByApplicability(a, b) {
    const isApplicable = (x) => x.nodeValue === false;
    if (isApplicable(a) === isApplicable(b)) {
        return 0;
    }
    return isApplicable(a) ? 1 : -1;
}
const Table = ({ explanation }) => (jsx_runtime_1.jsx(StyledContainer, { children: explanation.sort(sortByApplicability).map((node, i) => (jsx_runtime_1.jsx(Row, { node: node }, i))) }, void 0));
const StyledContainer = styled_components_1.default.div `
	display: flex;
	max-width: 100%;
	flex-direction: column;
`;
/* La colonne peut au clic afficher une nouvelle colonne qui sera une autre somme imbriquée */
function Row({ node }) {
    return (jsx_runtime_1.jsx(StyledRow, Object.assign({ className: node.nodeValue === false ? 'notApplicable' : '' }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: "element" }, { children: jsx_runtime_1.jsx(common_1.UnfoldIsEnabledContext.Provider, Object.assign({ value: true }, { children: jsx_runtime_1.jsx(Explanation_1.default, { node: node }, void 0) }), void 0) }), void 0) }), void 0));
}
const StyledSomme = styled_components_1.default.div `
	/* mécanisme somme */
	table {
		width: 100%;
		border-collapse: collapse;
	}
	tr .element {
		text-align: left;
		padding: 0.2rem 0.4rem;
	}
	tr .value span {
		text-align: right;
	}
	.nested {
		padding: 0;
	}
`;
const StyledRow = styled_components_1.default.div `
	display: flex;
	align-items: center;
	flex-flow: row nowrap;
	:nth-child(2n) {
		background-color: var(--lightestColor);
	}

	&.notApplicable {
		opacity: 0.6;
	}

	.element .result,
	:first-child {
		border-top: none;
	}

	.element {
		flex: 1;
		display: flex;
		max-width: 100%;
		align-items: baseline;

		padding: 0.1em 0.4em;
		padding-top: 0.2em;
		overflow: hidden;
		flex-wrap: wrap;
	}

	.element > * {
		flex: 1;
		display: flex;
		text-overflow: ellipsis;
	}
`;
